import axios from "axios";

const baseUrl = window.location.href.includes("localhost")
  ? "https://lily-factory.live/factory"
  : window.location.href.includes("netlify")
  ? "https://lily-factory.live/factory"
  : "https://lily-factory.live/factory";

export const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const bearerInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

// export const bearerInstanceWithToken = axios.create({
//   baseURL: "https://lily-factory.live/factory",
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/x-www-form-urlencoded",
//     Authorization: `Bearer ${token}`,
//   },
// });

export const bearerInstanceWithToken = (token) => {
  return axios.create({
    baseURL: baseUrl,
    headers: {
      // Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
